'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var pathToRegexp = _interopDefault(require('path-to-regexp'));

var React = _interopDefault(require('react'));

var rxjs = require('rxjs');

var operators = require('rxjs/operators');

var history = require('history');

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var HistoryManager =
/*#__PURE__*/
function () {
  function HistoryManager() {
    _classCallCheck(this, HistoryManager);

    this.history = null;
    this.historyCallback = null;
    this.silent = false;
  }

  _createClass(HistoryManager, [{
    key: "setHistory",
    value: function setHistory(history$$1) {
      this.history = history$$1;
    }
  }, {
    key: "setHistoryCallback",
    value: function setHistoryCallback(historyCallback) {
      this.historyCallback = historyCallback;
    }
  }, {
    key: "changeSilent",
    value: function changeSilent() {
      this.silent = true;
    }
  }, {
    key: "changeUnsilent",
    value: function changeUnsilent() {
      this.silent = false;
    }
  }, {
    key: "listen",
    value: function listen() {
      this.history.listen(this.listenCallback.bind(this));
    }
  }, {
    key: "listenCallback",
    value: function listenCallback(location) {
      if (!this.silent) this.historyCallback(location.pathname, function () {});
    }
  }, {
    key: "push",
    value: function push(pathname, callback) {
      this.changeSilent();
      this.historyCallback(pathname, callback);
      this.history.push(pathname);
      this.changeUnsilent();
    }
  }, {
    key: "createHref",
    value: function createHref(pathname) {
      return this.history.createHref({
        pathname: pathname
      });
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.history.location;
    }
  }]);

  return HistoryManager;
}();

var Request =
/*#__PURE__*/
function () {
  function Request(connector) {
    _classCallCheck(this, Request);

    this.connector = connector;
  }

  _createClass(Request, [{
    key: "to",
    value: function to(_to) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      this.connector.historyManager.push(this.normarizeTo(_to), callback);
    }
  }, {
    key: "name",
    value: function name(_name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var pathname = this.connector.routeMatcher.compileByName(_name, parameters);
      this.connector.historyManager.push(pathname, callback);
    }
  }, {
    key: "isActive",
    value: function isActive(pathname) {
      var location = this.connector.historyManager.getLocation();
      return location.pathname === pathname;
    }
  }, {
    key: "normarizeTo",
    value: function normarizeTo(to) {
      if (to[0] === "#") {
        return to.substr(1);
      }

      return to;
    }
  }]);

  return Request;
}();

var Renderer =
/*#__PURE__*/
function () {
  function Renderer(pathname, component, params, requestCallback, prevRenderer) {
    _classCallCheck(this, Renderer);

    this.data = {};
    this.component = component;
    this.params = params;
    this.requestCallback = requestCallback;
    this.pathname = pathname;
    this.prevRenderer = prevRenderer;
  }

  _createClass(Renderer, [{
    key: "getPathname",
    value: function getPathname() {
      return this.pathname;
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "getParams",
    value: function getParams() {
      return this.params;
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return {
        pathname: this.pathname,
        params: this.params
      };
    }
  }, {
    key: "getComponentProps",
    value: function getComponentProps() {
      return Object.assign(this.data, this.getProps());
    }
  }, {
    key: "getPrevProps",
    value: function getPrevProps() {
      return !!this.prevRenderer ? this.prevRenderer.getProps() : {};
    }
  }, {
    key: "getPrevComponentProps",
    value: function getPrevComponentProps() {
      if (!!this.prevRenderer) {
        return this.prevRenderer.getComponentProps();
      }

      return {};
    }
  }, {
    key: "fireInitialPropsWillGet",
    value: function fireInitialPropsWillGet() {
      if (this.isFunction(this.component.initialPropsWillGet)) {
        this.component.initialPropsWillGet(this.getProps(), this.getPrevProps());
      }

      return this;
    }
  }, {
    key: "fireGetInitialProps",
    value: function fireGetInitialProps() {
      var _this = this;

      if (!this.isFunction(this.component.getInitialProps)) {
        this.data = {};
        return Promise.resolve(this);
      }

      return Promise.resolve(this.component.getInitialProps(this.getProps(), this.getPrevProps())).then(function (params) {
        if (!!params) {
          _this.data = params;
          return _this;
        }

        _this.data = {};
        return _this;
      });
    }
  }, {
    key: "getInitialProps",
    value: function getInitialProps() {
      return this.data;
    }
  }, {
    key: "fireInitialPropsDidGet",
    value: function fireInitialPropsDidGet() {
      if (this.isFunction(this.component.initialPropsDidGet)) {
        this.component.initialPropsDidGet(this.getComponentProps(), this.getPrevComponentProps());
      }

      return this;
    }
  }, {
    key: "fireRequestCallback",
    value: function fireRequestCallback() {
      this.requestCallback();
      return this;
    }
  }, {
    key: "isFunction",
    value: function isFunction(func) {
      return !!func && typeof func === "function";
    }
  }, {
    key: "setInitialProps",
    value: function setInitialProps(data) {
      if (!data) {
        this.data = {};
        return this;
      }

      this.data = data;
      return this;
    }
  }]);

  return Renderer;
}();

var RouteMatcher =
/*#__PURE__*/
function () {
  function RouteMatcher() {
    _classCallCheck(this, RouteMatcher);

    this.init();
  }

  _createClass(RouteMatcher, [{
    key: "init",
    value: function init() {
      this.routes = [];
      this.nameRoutes = {};
      this.renderer = null;
      return this;
    }
  }, {
    key: "addRoute",
    value: function addRoute(path, component, name, isAsync) {
      this.routes.push({
        path: path,
        component: component,
        isAsync: isAsync
      });

      if (!!name) {
        this.nameRoutes[name] = path;
      }
    }
  }, {
    key: "createRenderer",
    value: function createRenderer(pathname, requestCallback) {
      var _this = this;

      var normalizedPathname = this.normalizePathname(pathname);

      var _loop = function _loop(i) {
        var keys = [];
        var route = _this.routes[i];
        var routeMatch = pathToRegexp(route.path, keys).exec(normalizedPathname);
        if (!routeMatch) return "continue";
        var params = {};

        for (var _i = 1, len = routeMatch.length; _i < len; ++_i) {
          var key = keys[_i - 1];
          params[key.name] = isNaN(routeMatch[_i]) ? decodeURIComponent(routeMatch[_i]) : Number(routeMatch[_i]);
        }

        return {
          v: _this.resolveComponent(route).then(function (component) {
            _this.renderer = new Renderer(normalizedPathname, component, params, requestCallback, _this.renderer);
            return _this.renderer;
          })
        };
      };

      for (var i = 0; this.routes.length > i; i++) {
        var _ret = _loop(i);

        switch (_ret) {
          case "continue":
            continue;

          default:
            if (_typeof(_ret) === "object") return _ret.v;
        }
      }

      this.renderer = null;
      return Promise.resolve(this.renderer);
    }
  }, {
    key: "resolveComponent",
    value: function resolveComponent(route) {
      if (!route.isAsync) {
        return Promise.resolve(route.component);
      }

      return route.component().then(function (component) {
        if (!!component && component.__esModule) {
          return component.default;
        }

        return component;
      });
    }
  }, {
    key: "compileByName",
    value: function compileByName(name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.nameRoutes[name]) {
        throw Error("Route Name \"".concat(name, "\" did not match Path."));
      }

      var toPath = pathToRegexp.compile(this.nameRoutes[name]);
      return toPath(parameters);
    }
  }, {
    key: "normalizePathname",
    value: function normalizePathname(pathname) {
      return pathname.split("?")[0].split("#")[0];
    }
  }]);

  return RouteMatcher;
}();

var URL =
/*#__PURE__*/
function () {
  function URL(connector) {
    _classCallCheck(this, URL);

    this.connector = connector;
  }

  _createClass(URL, [{
    key: "to",
    value: function to(pathname) {
      return this.connector.historyManager.createHref(pathname);
    }
  }, {
    key: "name",
    value: function name(_name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathname = this.connector.routeMatcher.compileByName(_name, parameters);
      return this.connector.historyManager.createHref(pathname);
    }
  }]);

  return URL;
}();

var Link =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, _getPrototypeOf(Link).apply(this, arguments));
  }

  _createClass(Link, [{
    key: "click",
    value: function click(e) {
      e.preventDefault();
      this.props.request.to(this.props.to, function () {
        window.scrollTo(0, 0);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("a", {
        href: this.props.to,
        className: this.props.className,
        onClick: this.click.bind(this)
      }, this.props.children);
    }
  }]);

  return Link;
}(React.Component);

function createLink(request) {
  return function (props) {
    return React.createElement(Link, _extends({
      request: request
    }, props));
  };
}

var ComponentResolver =
/*#__PURE__*/
function () {
  function ComponentResolver() {
    _classCallCheck(this, ComponentResolver);

    this.component = null;
  }

  _createClass(ComponentResolver, [{
    key: "setComponentFromRenderer",
    value: function setComponentFromRenderer(renderer) {
      this.setComponent(renderer.getComponent(), renderer.getComponentProps());
    }
  }, {
    key: "setComponent",
    value: function setComponent(component, componentProps) {
      this.component = function (props) {
        return React.createElement(component, _objectSpread({}, componentProps, props));
      };
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }]);

  return ComponentResolver;
}();

var Connector =
/*#__PURE__*/
function () {
  function Connector(historyManager, routeMatcher) {
    var componentResolver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, Connector);

    this.stream = null;
    this.historyManager = historyManager;
    this.routeMatcher = routeMatcher;
    this.componentResolver = componentResolver;

    this.onStateChange = function () {};
  }

  _createClass(Connector, [{
    key: "newInitializedInstance",
    value: function newInitializedInstance(history$$1) {
      var connector = new Connector(this.historyManager, this.routeMatcher, new ComponentResolver());
      connector.init(history$$1);
      return connector;
    }
  }, {
    key: "init",
    value: function init(history$$1) {
      this.initHistory(history$$1);
      this.initRouteMatcher();
      this.initStream();
      return this;
    }
  }, {
    key: "initHistory",
    value: function initHistory(history$$1) {
      this.historyManager.setHistory(history$$1);
      this.historyManager.setHistoryCallback(this.request.bind(this));
      this.historyManager.listen();
    }
  }, {
    key: "initRouteMatcher",
    value: function initRouteMatcher() {
      this.routeMatcher.init();
    }
  }, {
    key: "initStream",
    value: function initStream() {
      var _this = this;

      this.stream = new rxjs.Subject();
      this.stream.pipe(operators.switchMap(function (request) {
        return _this.routeMatcher.createRenderer(request.pathname, request.callback);
      }), operators.skipWhile(function (renderer) {
        return renderer === null;
      }), operators.map(function (renderer) {
        return renderer.fireInitialPropsWillGet();
      }), operators.mergeMap(function (renderer) {
        return renderer.fireGetInitialProps();
      }), operators.map(function (renderer) {
        return renderer.fireInitialPropsDidGet().fireRequestCallback();
      })).subscribe(function (renderer) {
        _this.componentResolver.setComponentFromRenderer(renderer);

        _this.onStateChange();
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(onStateChange) {
      this.onStateChange = onStateChange;
    }
  }, {
    key: "request",
    value: function request(pathname, callback) {
      this.stream.next({
        pathname: pathname,
        callback: callback
      });
    }
  }]);

  return Connector;
}();

var routeMatcher = new RouteMatcher();
var historyManager = new HistoryManager();
var connector = new Connector(historyManager, routeMatcher);
var request = new Request(connector);
var url = new URL(connector);
var link = createLink(request);

var RootComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RootComponent, _React$Component);

  function RootComponent(props) {
    var _this;

    _classCallCheck(this, RootComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RootComponent).call(this, props));
    props.connector.subscribe(_this.onStateChange.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    return _this;
  }

  _createClass(RootComponent, [{
    key: "onStateChange",
    value: function onStateChange() {
      this.setState({});
    }
    /**
     * Render the matching route.
     */

  }, {
    key: "render",
    value: function render() {
      var component = this.props.connector.componentResolver.getComponent();

      if (!component) {
        return null;
      }

      return React.createElement(component, _objectSpread({}, this.props));
    }
  }]);

  return RootComponent;
}(React.Component);

var InitialPropsRunner =
/*#__PURE__*/
function () {
  function InitialPropsRunner(connector, initialProps) {
    _classCallCheck(this, InitialPropsRunner);

    this.connector = connector;
    this.initialProps = initialProps;
  }

  _createClass(InitialPropsRunner, [{
    key: "run",
    value: function run(callback) {
      var _this = this;

      var location = this.connector.historyManager.getLocation();
      rxjs.of(location.pathname).pipe(operators.switchMap(function (pathname) {
        return _this.connector.routeMatcher.createRenderer(pathname);
      }), operators.skipWhile(function (renderer) {
        return renderer === null;
      }), operators.map(function (renderer) {
        return renderer.setInitialProps(_this.initialProps);
      })).subscribe(function (renderer) {
        _this.connector.componentResolver.setComponentFromRenderer(renderer);

        callback(function (props) {
          return React.createElement(RootComponent, _objectSpread({
            connector: _this.connector
          }, props));
        });
      });
    }
  }]);

  return InitialPropsRunner;
}();

var FirstComponentLoadRunner =
/*#__PURE__*/
function () {
  function FirstComponentLoadRunner(connector, firstComponent) {
    _classCallCheck(this, FirstComponentLoadRunner);

    this.connector = connector;
    this.firstComponent = firstComponent;
  }

  _createClass(FirstComponentLoadRunner, [{
    key: "run",
    value: function run(callback) {
      var _this = this;

      var location = this.connector.historyManager.getLocation();
      this.connector.request(location.pathname, function () {});
      this.connector.componentResolver.setComponent(this.firstComponent);
      callback(function (props) {
        return React.createElement(RootComponent, _objectSpread({
          connector: _this.connector
        }, props));
      });
    }
  }]);

  return FirstComponentLoadRunner;
}();

var LoadRunner =
/*#__PURE__*/
function () {
  function LoadRunner(connector) {
    _classCallCheck(this, LoadRunner);

    this.connector = connector;
  }

  _createClass(LoadRunner, [{
    key: "run",
    value: function run(callback) {
      var _this = this;

      var location = this.connector.historyManager.getLocation();
      rxjs.of(location.pathname).pipe(operators.switchMap(function (pathname) {
        return _this.connector.routeMatcher.createRenderer(pathname);
      }), operators.skipWhile(function (renderer) {
        return renderer === null;
      }), operators.map(function (renderer) {
        return renderer.fireInitialPropsWillGet();
      }), operators.mergeMap(function (renderer) {
        return renderer.fireGetInitialProps();
      }), operators.map(function (renderer) {
        return renderer.fireInitialPropsDidGet();
      })).subscribe(function (renderer) {
        _this.connector.componentResolver.setComponentFromRenderer(renderer);

        callback(function (props) {
          return React.createElement(RootComponent, _objectSpread({
            connector: _this.connector
          }, props));
        });
      });
    }
  }]);

  return LoadRunner;
}();

var Router =
/*#__PURE__*/
function () {
  function Router(connector) {
    _classCallCheck(this, Router);

    this.connector = connector;
    this.initialProps = null;
    this.firstComponent = null;
  }

  _createClass(Router, [{
    key: "route",
    value: function route(path, component, name) {
      this.connector.routeMatcher.addRoute(path, component, name, false);
    }
  }, {
    key: "asyncRoute",
    value: function asyncRoute(path, component, name) {
      this.connector.routeMatcher.addRoute(path, component, name, true);
    }
  }, {
    key: "setFirstComponent",
    value: function setFirstComponent(component) {
      this.firstComponent = component;
    }
  }, {
    key: "setInitialProps",
    value: function setInitialProps(initialProps) {
      this.initialProps = initialProps;
    }
  }, {
    key: "run",
    value: function run(callback) {
      var runner = this.getRunner();
      runner.run(callback);
    }
  }, {
    key: "getRunner",
    value: function getRunner() {
      if (!!this.initialProps) {
        return new InitialPropsRunner(this.connector, this.initialProps);
      }

      if (!!this.firstComponent) {
        return new FirstComponentLoadRunner(this.connector, this.firstComponent);
      }

      return new LoadRunner(this.connector);
    }
  }]);

  return Router;
}();

var ServerRouter =
/*#__PURE__*/
function () {
  function ServerRouter(routeMatcher) {
    _classCallCheck(this, ServerRouter);

    this.routeMatcher = routeMatcher;
  }

  _createClass(ServerRouter, [{
    key: "route",
    value: function route(path, component, name) {
      this.routeMatcher.addRoute(path, component, name, false);
    }
  }, {
    key: "asyncRoute",
    value: function asyncRoute(path, component, name) {
      this.routeMatcher.addRoute(path, component, name, true);
    }
  }, {
    key: "runUsingPathname",
    value: function runUsingPathname(pathname, callback) {
      var _this = this;

      rxjs.of(pathname).pipe(operators.switchMap(function (pathname) {
        return _this.routeMatcher.createRenderer(pathname);
      }), operators.skipWhile(function (renderer) {
        return renderer === null;
      }), operators.mergeMap(function (renderer) {
        return renderer.fireGetInitialProps();
      })).subscribe(function (renderer) {
        var componentResolver = new ComponentResolver();
        componentResolver.setComponentFromRenderer(renderer);
        callback(function (props) {
          return React.createElement(componentResolver.getComponent(), _objectSpread({}, props));
        }, renderer.getInitialProps());
      });
    }
  }]);

  return ServerRouter;
}();

function createRouter() {
  // Settings HistoryManager.
  return new Router(connector.newInitializedInstance(history.createBrowserHistory()));
}

function createServerRouter() {
  // Must define history. Because history is used in Request, URL, etc..
  connector.initHistory(history.createMemoryHistory());
  connector.initRouteMatcher();
  return new ServerRouter(connector.routeMatcher);
}

var index =
/*#__PURE__*/
Object.freeze({
  createRouter: createRouter,
  createServerRouter: createServerRouter
});

function createRouter$1() {
  var history$$1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : history.createHashHistory();
  return new Router(connector.newInitializedInstance(history$$1));
}

exports.createBrowserHistory = history.createBrowserHistory;
exports.createHashHistory = history.createHashHistory;
exports.createMemoryHistory = history.createMemoryHistory;
exports.createRouter = createRouter$1;
exports.Link = link;
exports.Request = request;
exports.URL = url;
exports.SSR = index;